import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ToastService, ToastType } from './toast.service';

export enum ToastPosition {
  APP = 'app',
  FORM = 'form',
}

@Component({
  standalone: true,
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],
  imports: [CommonModule],
})
export class ToastComponent {
  toastService = inject(ToastService);
  ToastType = ToastType;
  @Input() position = ToastPosition.APP;
  ToastPosition = ToastPosition;
}
